import { paramRate, paramValues } from '../constants/parameterNames';
import { parseAndValidateCashflowSeries } from '../helpers/financial.helpers';
import {
    getDoubleParamValue,
    getParamValue,
} from '../helpers/parameter.accessors';

const requiredParameters = {
    [paramRate]: {
        description: 'Discount rate over the length of the period.',
    },
    [paramValues]: {
        description:
            'Comma delimited list of cash flow values - must contain at least one negative value and at least one positive value.',
    },
};

const optionalParameters = [];

const description =
    'Returns a value specifying the net present value of an investment based on a series of periodic cash flows (payments and receipts) and a discount rate.';

export const getSettings = (parameters) => ({
    rate: getDoubleParamValue(parameters, paramRate, null, false),
    valueArray: parseAndValidateCashflowSeries(
        getParamValue(parameters, paramValues),
    ),
});

const executeAsync = async ({ api, parameters }) => {
    const settings = getSettings(parameters);

    return await api.netPresentValue(settings);
};

const Npv = {
    description,
    executeAsync,
    optionalParameters,
    requiredParameters,
};

export default Npv;
